<template>
  <div>
    <router-link to="/">
      <el-image
        :src="require(`@/assets/logo-primary.png`)"
        class="text-left"
      ></el-image>
    </router-link>
    <h2 class="color-primary text-weight-600">
      {{ title }}
    </h2>
    <div v-if="showSigninWith" class="flex-display js-center">
      <div
        @click="signinWithFaceBook()"
        class="box-signin-socail mg-x-4 cursor-pointer"
        style="background-color: #0065b3"
      >
        <i class="fab fa-facebook-f color-white"></i>
      </div>

      <div
        @click="signinWithGoogle()"
        class="box-signin-socail mg-x-4 cursor-pointer"
        style="background-color: #ffffff"
      >
        <el-image
          :src="require('@/assets/google.png')"
          class="text-left vc-middle"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/service/axios.js";

export default {
  props: {
    title: {
      type: String,
      default() {
        return "";
      },
    },
    showSigninWith: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    async signinWithGoogle(googleUser) {
      var auth2 = gapi.auth2.getAuthInstance();
      auth2.signIn().then(async (res) => {
        let profile = auth2.currentUser.get().getBasicProfile();

        let password = "";

        let email = "";
        let name = "";
        let lastName = "";
        let image = "";

        Object.keys(profile).forEach((key, index) => {
          if (index == 0) {
            password = `${profile[key]}t@t.wiThGoogle`;
          }

          if (index == 5) {
            email = profile[key];
          }

          if (index == 2) {
            name = profile[key];
          }

          if (index == 3) {
            lastName = profile[key];
          }

          if (index == 4) {
            image = profile[key];
          }
        });

        let haveEmail = await this.haveEmail(email);

        if (haveEmail) {
          this.$emit("signIn", email, password);
        } else {
          let obj = {
            nameTh: name,
            lastNameTh: lastName,
            image: image,
            email: email,
            password: password,
          };

          this.signup(obj, "google");
        }
      });
    },
    async signinWithFaceBook() {
      FB.login(
        (responseLogin) => {
          if (responseLogin.authResponse) {
            FB.api(
              "/me",
              "GET",
              {
                fields:
                  "id,first_name,last_name,email,picture.width(480).height(480)",
              },
              async (response) => {
                let haveEmail = await this.haveEmail(response.email);
                let password = `${response.id}t@t.wiThFaceBook`;
                if (haveEmail) {
                  this.$emit("signIn", response.email, password);
                } else {
                  let obj = {
                    nameTh: response.first_name,
                    lastNameTh: response.last_name,
                    email: response.email,
                    image: response.id,
                    password: password,
                  };

                  this.signup(obj, "faceBook");
                }
              }
            );
          }
        },
        { scope: "email" }
      );
    },
    async haveEmail(email) {
      let have = false;
      let obj = {
        email: email,
      };

      await HTTP.post(`email`, obj).then((res) => {
        if (res.data.success) {
          have = false;
        } else {
          have = true;
        }
      });

      return have;
    },
    signup(obj, from) {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();

      formData.append("profileFrom", obj.image);
      formData.append("titleName", "");
      formData.append("nameTH", obj.nameTh);
      formData.append("surnameTH", obj.lastNameTh);
      formData.append("nameEN", "");
      formData.append("surnameEN", "");
      formData.append("countryCode", "");
      formData.append("mobilephone", "");
      formData.append("identification", "");
      formData.append("birthday", "");
      formData.append("position", "");
      formData.append("address", "");
      formData.append("postcode", "");
      formData.append("subdistrict", "");
      formData.append("district", "");
      formData.append("province", "");

      let institution = {
        name: "",
        type: "",
        etc: "",
        address: "",
        postcode: "",
        subdistrict: "",
        district: "",
        province: "",
      };

      formData.append("institution", JSON.stringify(institution));
      formData.append("email", obj.email);
      formData.append("password", obj.password);
      formData.append("from", from);

      HTTP.post(`sign/up`, formData, config)
        .then((res) => {
          if (res.data.success) {
            this.$emit("signIn", obj.email, obj.password);
          } else {
            this.$alert("เข้าสู่ระบบไม่สำเร็จกรุณาลองใหม่อีกครั้ง", {
              closeOnClickModal: true,
              confirmButtonText: "OK",
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$alert("เข้าสู่ระบบไม่สำเร็จกรุณาลองใหม่อีกครั้ง", {
            closeOnClickModal: true,
            confirmButtonText: "OK",
            type: "error",
          });
          console.log("signup error", e);
        });
    },
  },
};
</script>